import { Reducer } from '@reduxjs/toolkit';
import { Action } from 'modules/types/common';
import { FetchingReducerState } from 'store/setLocalStore';

export interface AuthLiteRequest {
  scope: string;
  eventId: string;
  lastName: string;
  dob: string;
  zipCode?: string;
}

export interface AuthLiteResponse {
  accessToken: string;
  consumerId: string;
  dfdEventId: string;
  personId: string;
  clinicalEventId: string;
  detailsEndpoint: string;
}

export type AuthLiteState = FetchingReducerState<AuthLiteResponse>;

export type AuthLiteReducer = Reducer<AuthLiteState, Action>;

export enum LoginType {
  PASSWORD = 'password',
  STORED_AUTH = 'stored auth'
}
